// Central definition of the product's web URLs, so links live in one place and
// the domains are environment-driven. These builders own the *path* structure;
// each app passes the *base* URL from its own environment:
//   RN  → EXPO_PUBLIC_MARKETING_URL / EXPO_PUBLIC_APP_URL (see src/config/urls.ts)
//   web → VITE_MARKETING_URL, or window.location.origin (see apps/web/src/lib/urls.ts)
// The defaults below are the live domains, so a missing env var still works.

// Marketing / brochure site — hosts the public help + policy pages.
export const DEFAULT_MARKETING_URL = "https://reciperoll.app";
// Web-app host — also the universal-link / auth-redirect target for native.
export const DEFAULT_APP_URL = "https://my.reciperoll.app";

const stripTrailingSlash = (url: string) => url.replace(/\/+$/, "");

// Public policy/support pages, built from the marketing base (reciperoll.app).
export function marketingUrls(base: string = DEFAULT_MARKETING_URL) {
  const b = stripTrailingSlash(base);
  return {
    privacy: `${b}/privacy-policy`,
    terms: `${b}/terms-of-service`,
    support: `${b}/support`,
    about: `${b}/about`,
  };
}

// Auth deep-link redirect targets on the web-app host (my.reciperoll.app). Native
// only — the web app derives these from window.location.origin instead.
export function appAuthRedirects(base: string = DEFAULT_APP_URL) {
  const b = stripTrailingSlash(base);
  return {
    confirm: `${b}/confirm`,
    resetPassword: `${b}/reset-password`,
  };
}
